'use strict';
/* Directives for the autoremind.communication feature */
angular.module('autoremind.communications')
    .directive('response', function () {
    return {
        restrict: 'E',
        //transclude: true,
        template: ''
    };
});
//# sourceMappingURL=communications.directives.js.map